import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../../../utils/theme";
import Swal from "sweetalert2";
import Input from "./FormInput/Input";
import Select from "./FormInput/Select";

import { useNavigate } from "react-router-dom";

import Radio from "./FormInput/Radio";

import { useDataContex } from "../../../hooks/Context/PatientProvider";
import { IPatient, ISelectOption } from "../../../interfaces/Patient";
/* --------------------------------xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx------------------------------------------------------- */
// IMFORMACION DE PACIENTE

const ContainerInfo = styled.div`
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 2rem;
    @media (max-width: 500px) {
      flex-direction: column-reverse;
    }
  }

  .title1 {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    display: block;
    margin-left: auto;
    align-self: center;
    @media (max-width: 600px) {
      font-size: 1.5rem;
    }
    @media (max-width: 500px) {
      margin: 0 auto;
      width: 100%;
      text-align: center;
    }
  }

  .arrow {
    display: block;
    margin-left: auto;
    align-self: center;
    @media (max-width: 500px) {
      margin: 0 auto;
    }
    .bx {
      background-color: ${colors.blanco};
      font-size: 2rem;
      color: ${colors.fifth};
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

const ContainerFormInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;
const FormInputInfo = styled.div`
  width: 25%;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (max-width: 1440px) {
    width: 30%;
  }
  @media (max-width: 768px) {
    width: 45%;
  }
  @media (max-width: 500px) {
    width: 90%;
  }

  label {
    color: ${colors.third};
    font-weight: 600;
  }

  .ID {
    display: flex;
    gap: 10px;

    .selectContainer {
      width: 20%;
    }

    .inputContainer {
      width: 80%;
    }
  }

  .DATE {
    display: flex;
    gap: 10px;

    .selectContainer {
      width: 33%;
    }
    .inputContainer {
      width: 33%;
    }
  }

  .SEX {
  }
`;

/* --------------------------------xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx------------------------------------------------------- */
// CONTACTO DEL PACIENTE

const ContainerContact = styled.div`
  .container_title {
    display: flex;
    background-color: ${colors.gris};
    padding: 1rem;
    justify-content: center;
    align-items: center;
    margin: 2rem 0;
  }

  .title2 {
    color: ${colors.primary};
    text-align: center;
    align-self: center;
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 600px) {
      font-size: 1.5rem;
    }
    @media (max-width: 375px) {
      font-size: 1.4rem;
    }
  }
`;

const ContainerFormContact = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;
const FormInputContact = styled.div`
  width: 30%;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 45%;
  }

  @media (max-width: 500px) {
    width: 90%;
  }

  label {
    color: ${colors.third};
    font-weight: 600;
  }

  .number {
    width: 70%;
    align-self: center;
    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .email {
    width: 100%;
  }
`;

const ContainerTerms = styled.div`
  margin: 2rem auto;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  @media (max-width: 1200px) {
    width: 70%;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }

  label {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.fifth};
    gap: 5px;
  }

  input {
    width: 20px;
    height: 20px;
    color: ${colors.fifth};
    cursor: pointer;
  }
  .acepto {
    color: ${colors.azul};
  }

  .button {
    width: 50%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 600px) {
      width: 80%;
    }

    @media (max-width: 375px) {
      font-size: 0.8rem;
    }
  }
`;

export const InfoComponent = () => {
  // Uso del hook useNavigate de React Router para la navegación programática
  const navigate = useNavigate();

  const [formData, setFormData] = useState<IPatient>({
    id: { field: "", isValid: null, selectedValue: "" },
    idNumber: { field: "", isValid: null },
    firstName: { field: "", isValid: null },
    lastName: { field: "", isValid: null },
    birthDay: { field: "", isValid: null },
    birthMonth: { field: "", isValid: null, selectedValue: "" },
    birthYear: { field: "", isValid: null },
    gender: { field: "", isValid: null, selectedValue: "" },
    phone: { field: "", isValid: null },
    email: { field: "", isValid: null },
    termsAccepted: { field: "", isValid: null },
    address: { field: "", isValid: null },
    relationship: { field: "", isValid: null, selectedValue: "" },
    emergencyContact: { field: "", isValid: null },
    emergencyPhone: { field: "", isValid: null },
  });

  // Hook personalizado para establecer los datos en un contexto o estado global
  const { setData } = useDataContex();

  // Verificación de que todos los campos del formulario son válidos
    
  const allFieldsValid = Object.values(formData).every((field) => field.isValid);

  const expresiones = {
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    correo: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    telefono: /^(?:\+\d+)?\d{10}$/, 
    id: /^\d{1,15}$/,
    diaMes: /^([1-9]|[12][0-9]|3[01])$/,
    año: /^\d{4}$/,
    textArea: /^.{0,150}$/,
    campoVacio: /^.{5,50}$/,
  };

  const IDS = [
    { value: "CC", label: "CC" },
    { value: "TI", label: "TI" },
    { value: "CE", label: "CE" },
    { value: "PA", label: "PA" },
    { value: "RC", label: "RC" }
  ];

  const SEX = [
    { value: "M", label: "Masculino" },
    { value: "F", label: "Femenino" },
  ];

  const PARENTESCO = [
    { value: 1, label: "CONYUGE/PAREJA" },
    { value: 2, label: "PADRE/MADRE" },
    { value: 3, label: "HIJO/A" },
    { value: 4, label: "HERMANO/A" },
    { value: 5, label: "AMIGO/A" },
    { value: 6, label: "OTRO" },
  ];

  const months = [
    { value: "01", label: "Enero" },
    { value: "02", label: "Febrero" },
    { value: "03", label: "Marzo" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Mayo" },
    { value: "06", label: "Junio" },
    { value: "07", label: "Julio" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];

  // Función para manejar el envío del formulario
  const onSutmit = (e) => {
    e.preventDefault();
    if (allFieldsValid) {
      // Si todos los campos son válidos
      Swal.fire({
        title: "¡Formulario exitoso!",
        text: "Campos correctos",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      setTimeout(() => {
        navigate("/orden"); // Navegar a la página /orden después de un retraso
      }, 1500);
      setData([formData]); // Actualizar los datos en el contexto o estado global
    } else {
      // Si algún campo no es válido
      const updatedFormData = { ...formData };

      // Establecer el estado de validez de cada campo
      for (const key in updatedFormData) {
        updatedFormData[key].isValid = updatedFormData[key].isValid === true;
      }
      setFormData(updatedFormData);
      
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rellene todos lo campos faltante!",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#ec2323",
      });
    }
  };

  // Función para manejar la navegación condicional basada en la validez del formulario
  const handleNavigation = () => {
    if (allFieldsValid) {
      Swal.fire({
        title: "¡Formulario exitoso!",
        text: "Campos correctos",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      setTimeout(() => {
        navigate("/orden"); // Navegar a la página /orden después de un retraso
      }, 1500);
      setData((prev) => [...prev, formData]); // Actualizar los datos en el contexto o estado global
    } else {
      
      
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "rellene los campos antes de pasar a la siguiente pagina!",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#ec2323",
      });
    }
  };
  const [expId, setExpId] = useState(expresiones.id);

  const handleRestriction = (e) => {
    if (e === "PA" || e === "CE") {
      setExpId(/^[a-zA-Z0-9\-\/]+$/);
    } else {
      setExpId(/^\d{1,15}$/);
    }
  }

  return (
    <ContainerInfo>
      <div className="paginator">
        <span className="title1">INFORMACIÓN DEL PACIENTE</span>
        <span className="arrow" onClick={handleNavigation}>
          <i className="bx bx-chevron-right"></i>
        </span>
      </div>
      <form onSubmit={onSutmit}>
        <ContainerFormInfo>
          {/* id */}
          <FormInputInfo>
            <label>DOCUMENTO ID</label>
            <div className="ID">
              <div className="selectContainer">
                <Select
                  state={formData.id}
                  changeState={(newState) =>
                    setFormData({ ...formData, id: newState })
                  }
                  placeholder="ID"
                  options={IDS}
                  legendError="ID"
                />
              </div>

              <div className="inputContainer">
                <Input
                  state={formData.idNumber}
                  changeState={(newState) => {
                    setFormData({ ...formData, idNumber: newState })
                    handleRestriction(formData.id.field);
                  }}
                  placeholder="No. ID SIN PUNTOS*"
                  type="text"
                  legendError="Seleccione Su ID y Digite Su Identificación, Solo Numeros"
                  expressionRegular={expId}
                />
              </div>
            </div>
          </FormInputInfo>

          {/* Names */}
          <FormInputInfo>
            <label>PRIMER NOMBRE</label>
            <Input
              state={formData.firstName}
              changeState={(newState) =>
                setFormData({ ...formData, firstName: newState })
              }
              placeholder="PRIMER NOMBRE"
              type="text"
              legendError="Digite Su Nombre Sin Numeros Ni Carácteres Especiales"
              expressionRegular={expresiones.nombre}
            />
          </FormInputInfo>
          {/* Surnames */}
          <FormInputInfo>
            <label>PRIMER APELLIDO</label>
            <Input
              state={formData.lastName}
              changeState={(newState) =>
                setFormData({ ...formData, lastName: newState })
              }
              placeholder="PRIMER APELLIDO"
              type="text"
              legendError="Digite Su Apellido Sin Numeros Ni Carácteres Especiales"
              expressionRegular={expresiones.nombre}
            />
          </FormInputInfo>

          {/* Date */}
          <FormInputInfo>
            <label>F. NACIMIENTO</label>
            <div className="DATE">
              <div className="inputContainer">
                <Input
                  state={formData.birthDay}
                  changeState={(newState) =>
                    setFormData({ ...formData, birthDay: newState })
                  }
                  placeholder="DIA"
                  type="text"
                  legendError="Digite Su Dia desde el 1-31"
                  expressionRegular={expresiones.diaMes}
                />
              </div>

              <div className="selectContainer">
                <Select
                  state={formData.birthMonth}
                  changeState={(newState) =>
                    setFormData({ ...formData, birthMonth: newState })
                  }
                  placeholder="Mes"
                  options={months}
                  legendError="Elija Su mes"
                />
              </div>

              <div className="inputContainer">
                <Input
                  state={formData.birthYear}
                  changeState={(newState) =>
                    setFormData({ ...formData, birthYear: newState })
                  }
                  placeholder="AÑO"
                  type="text"
                  legendError="Digite Su Año Solo numeros"
                  expressionRegular={expresiones.año}
                  validateYear={true}
                />
              </div>
            </div>
          </FormInputInfo>
          <FormInputInfo>
            <label>SEXO</label>
            <div className="SEX">
              <div className="selectContainer">
                <Select
                  state={formData.gender}
                  changeState={(newState) =>
                    setFormData({ ...formData, gender: newState })
                  }
                  placeholder="Elija su Sexo"
                  options={SEX}
                  legendError="Elija Su Sexo"
                />
              </div>
            </div>
          </FormInputInfo>

          <FormInputInfo>
            <label>Dirección</label>
            <Input
              state={formData.address}
              changeState={(newState) =>
                setFormData({ ...formData, address: newState })
              }
              placeholder="DIRECCIÓN"
              type="text"
              legendError="Digite Su direccion valida"
              expressionRegular={expresiones.campoVacio}
            />
          </FormInputInfo>
        </ContainerFormInfo>
        {/* --------------------------------xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx------------------------------------------------------- */}
        <ContainerContact>
          <div className="container_title">
            <span className="title2">INFORMACIÓN DE CONTACTO DEL PACIENTE</span>
          </div>
          <ContainerFormContact>
            <FormInputContact>
              <label className="number">TELÉFONO MOVIL</label>
              <div className="number">
                <Input
                  state={formData.phone}
                  changeState={(newState) =>
                    setFormData({ ...formData, phone: newState })
                  }
                  placeholder="NÚMERO DE CELULAR"
                  type="text"
                  legendError="Su numero telefónico por lo menos debe de tener 10 dígitos"
                  expressionRegular={expresiones.telefono}
                />
              </div>
            </FormInputContact>

            <FormInputContact>
              <label>CORREO ELECTRÓNICO</label>
              <Input
                state={formData.email}
                changeState={(newState) =>
                  setFormData({ ...formData, email: newState })
                }
                placeholder="EMAIL"
                type="text"
                legendError="El Correo Debe Ser Valido @ .com"
                expressionRegular={expresiones.correo}
              />
            </FormInputContact>
            <FormInputInfo>
              <label>CONTACTO DE EMERGENCIA</label>
              <Input
                state={formData.emergencyContact}
                changeState={(newState) =>
                  setFormData({ ...formData, emergencyContact: newState })
                }
                placeholder="PRIMER NOMBRE"
                type="text"
                legendError="Digite Su Nombre Sin Numeros Ni Carácteres Especiales"
                expressionRegular={expresiones.nombre}
              />
            </FormInputInfo>
            <FormInputInfo>
              <label>PARENTESCO</label>
              <div className="SEX">
                <div className="selectContainer">
                  <Select
                    state={formData.relationship}
                    changeState={(newState) =>
                      setFormData({ ...formData, relationship: newState })
                    }
                    placeholder="Elija su Parentesco"
                    options={PARENTESCO}
                    legendError="Elija Su Parentesco"
                  />
                </div>
              </div>
            </FormInputInfo>
            <FormInputContact>
              <label className="number">TELÉFONO EMERGENCIA</label>
              <div className="number">
                <Input
                  state={formData.emergencyPhone}
                  changeState={(newState) =>
                    setFormData({ ...formData, emergencyPhone: newState })
                  }
                  placeholder="NÚMERO DE CELULAR"
                  type="text"
                  legendError="Su numero telefónico por lo menos debe de tener 10 dígitos"
                  expressionRegular={expresiones.telefono}
                />
              </div>
            </FormInputContact>
          </ContainerFormContact>
          <ContainerTerms>
            <Radio
              label="Aceptar los terminos"
              value="Acepto"
              state={formData.termsAccepted}
              changeState={(newState) =>
                setFormData({ ...formData, termsAccepted: newState })
              }
            />
            {/* <Link className="button" to="/orden">
          CONTINUAR AGENDAMIENTO
        </Link> */}
            <button className="button" type="submit">
              CONTINUAR AGENDAMIENTO
            </button>
          </ContainerTerms>
        </ContainerContact>
      </form>
    </ContainerInfo>
  );
};
